import { InjectionToken } from '@angular/core';
import { environment } from '../../../environments/environment';
import { AppConstant } from '../models/app-constant';
export const APP_CONSTANTS = new InjectionToken('APP_CONSTANTS');

export const CONSTANTS: AppConstant = {
    PROTOCOL: environment.PROTOCOL,
    IP: environment.IP,
    API_PATHS: environment.API_PATHS,
};
